var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('el-header',{staticStyle:{"padding":"0"},attrs:{"height":"120px"}},[_c('systemHeader')],1),_c('el-main',{staticClass:"mian_bottom",staticStyle:{"padding":"0"}},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }